module.exports = __webpack_public_path__ + "static/media/20240213111321_IMG_5356.bc73333e.JPG";